// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { AccountOperationInfoMessageProcessor, AccountOperationMessageProcessor, AccountStatusMessageProcessor, AlertMessageProcessor, AlgorithmGainersLosersMessageProcessor, AlgorithmHighLowMessageProcessor, AlgorithmMarketConsensusMessageProcessor, AlgorithmsAvailableMessageProcessor, AlgorithmSubscribeMessageProcessor, AlgorithmTopVolumeMessageProcessor, AssetTypeMessageProcessor, BMCounterMessageProcessor, BMHistoryResponseMessageProcessor, BrandingRulesMessageProcessor, BrokerMessageProcessor, BrokerMessageResponseCaseMessageProcessor, BusinessRejectMessageProcessor, ChangePasswordMessageProcessor, ChangeTradingPasswordMessageProcessor, ClosePositionMessageProcessor, CompressedMessageProcessor, ControlAlertCommandMessageProcessor, CrossRateMessageProcessor, CrossRatesPlanMessageProcessor, CustodialPlanMessageProcessor, CustomListMessageProcessor, EntitlementProductDocumentResponseMessageProcessor, EntitlementProductMessageProcessor, EntitlementProductSubscriptionResponseMessageProcessor, ExternalLinkMessageProcessor, ExternalLinkRemoveMessageProcessor, HelloMessageProcessor, InformationMessageProcessor, InputInitDataRequstMessageProcessor, InstrumentDayBarMessageProcessor, InstrumentMessageProcessor, InstrumentPricesMessageProcessor, InstrumentGroupMessageProcessor, InstrumentUpdateMessageProcessor, LogonMessageProcessor, LogoutMessageProcessor, MarginCallMessageProcessor, MarginResponseMessageProcessor, type MessageProcessorBase, NewsMessageProcessor, NewsSubscribeResponseProcessor, NonFixedInstumentListResponseMessageProcessor, NonFixedInstumentStrikesResponseMessageProcessor, OneTimePasswordMessageProcessor, OpenOrderMessageProcessor, OrderDialogMessageProcessor, PasswordRecoveryChangeMessageProcessor, PFixHistoryMessageProcessor, PingMessageProcessor, PortfolioInvestorMessageProcessor, PortfolioModelMessageProcessor, PortfolioRealtimeStatisticsMessageProcessor, PortfolioStatisticsMessageProcessor, PortfolioSystemMessageProcessor, PositionMessageProcessor, PropertyMessageProcessor, Quote1MessageProcessor, Quote2AggregatedMessageProcessor, Quote2MessageProcessor, Quote3MessageProcessor, RefreshTokenProcessor, ReplaceAlertMessageProcessor, ReportGroupResponseMessageProcessor, ReportTypeMessageProcessor, RevenuePlanMessageProcessor, RiskPlanMessageProcessor, RiskWarningMessageProcessor, RouteMessageProcessor, SessionMessageProcessor, SessionSwitchMessageProcessor, SnapshotResponseMessageProcessor, SOAPMessageProcessor, SourceListProcessor, SubscribeMessageProcessor, SubscriptionStrategyMessageProccesor, SubscriptionStrategyRequestMessageProccesor, TokenVerifyResponseMessageProcessor, TradeMessageProcessor, TradeSessionStatusMessageProcessor, TradingSignalCancelMessageProcessor, TradingSignalMessageProcessor, TradingSignalRequestMessageProcessor, TradingSignalSeenRequestMessageProcessor, TradingSystemMessageProcessor, TradingSystemRemoveMessageProcessor, TradingUnlockResponseProcessor, UserGroupMessageProcessor, XMLMessageProcessor, YTMMessageProcessor, PriceLimitsMessageProcessor, CloseAccountResponseMessageProcessor, AlgorithmHeatmapMessageProcessor } from '../MessageProcessors/ProcessorsImport';

import { FundingRateMarkupPlanMessageProcessor } from '../MessageProcessors/FundingRateMarkupPlanMessageProcessor';

import { Message } from '../../../../Utils/DirectMessages/Message';
import { AlgorithmHistoricalGainersLosersTopsMessageProcessor } from '../MessageProcessors/Algorithm/AlgorithmHistoricalGainersLosersTopsMessageProcessor';
import { type PFixFieldSet } from '../Fields/PFixFieldSet';
import { MamGroupProcessor } from '../MessageProcessors/MamGroupProcessor';

export class MsgDecoder {
    public parent: any;
    public FProcTable: Record<number, MessageProcessorBase> = {};

    public FInstrumentDecodeMap: Record<number, string> = {};
    public FSymbolDecodeMap: Record<string, number> = {};
    public FRouteDecodeMap: Record<number, string> = {};
    public FAssetDecodeMap = {};
    public FIdRouteDecodeMap: Record<string, number> = {};
    public FQuoteRouteMap = {};
    public FSourceDecodeMap: Record<number, string> = {};

    constructor (pfixMsgProcessor) {
        this.parent = pfixMsgProcessor || null;

        const parent = this.parent;

        this.FProcTable[Message.CODE_PFIX_LOGON_MESSAGE] = new LogonMessageProcessor(this);
        this.FProcTable[Message.CODE_PFIX_HELLO_MESSAGE] = new HelloMessageProcessor();
        this.FProcTable[Message.CODE_ACCOUNTSTATUS] = new AccountStatusMessageProcessor();
        this.FProcTable[Message.CODE_INSTRUMENT] = new InstrumentMessageProcessor(this);
        this.FProcTable[Message.CODE_INSTRUMENT_LIST_RESPONSE] = new NonFixedInstumentListResponseMessageProcessor(this);
        this.FProcTable[Message.CODE_QUOTE] = new Quote1MessageProcessor(this, parent);
        this.FProcTable[Message.CODE_QUOTE2] = new Quote2MessageProcessor(this);
        this.FProcTable[Message.CODE_QUOTE3] = new Quote3MessageProcessor(this);
        // this.FProcTable[Message.CODE_QUOTE4] = new Quote4MessageProcessor(this, parent)
        this.FProcTable[Message.CODE_SUBSCRIBE_RESPONSE_MESSAGE] = new SubscribeMessageProcessor(this);
        this.FProcTable[Message.CODE_PFIX_PING_MESSAGE] = new PingMessageProcessor();
        this.FProcTable[Message.CODE_INSTRUMENT_TYPE] = new InstrumentGroupMessageProcessor();
        this.FProcTable[Message.CODE_OPENORDER] = new OpenOrderMessageProcessor(this);
        this.FProcTable[Message.CODE_OPENPOSITION] = new PositionMessageProcessor(this);
        this.FProcTable[Message.CODE_CLOSEPOSITION] = new ClosePositionMessageProcessor(this);
        this.FProcTable[Message.CODE_INSTRUMENT_DAY_BAR] = new InstrumentDayBarMessageProcessor(this);
        this.FProcTable[Message.CODE_INSTRUMENT_PRICES] = new InstrumentPricesMessageProcessor(this);
        this.FProcTable[Message.CODE_CROSSRATE_MESSAGE] = new CrossRateMessageProcessor(this);
        this.FProcTable[Message.CODE_CROSSRATES_PLAN_MESSAGE] = new CrossRatesPlanMessageProcessor();
        this.FProcTable[Message.CODE_TRADE] = new TradeMessageProcessor(this);
        this.FProcTable[Message.CODE_PFIX_PROPERTY_MESSAGE] = new PropertyMessageProcessor();
        this.FProcTable[Message.CODE_SOURCE_LIST] = new SourceListProcessor(this);
        this.FProcTable[Message.CODE_REPORT_TYPE_MESSAGE] = new ReportTypeMessageProcessor();
        this.FProcTable[Message.CODE_ASSET_TYPE_MESSAGE] = new AssetTypeMessageProcessor();
        this.FProcTable[Message.CODE_SESSION_MESSAGE] = new SessionMessageProcessor();
        this.FProcTable[Message.CODE_INIT_DATA_REQUEST] = new InputInitDataRequstMessageProcessor();
        this.FProcTable[Message.CODE_ROUTE] = new RouteMessageProcessor(this);
        this.FProcTable[Message.CODE_NEW_ORDER_MESSAGE] = new OrderDialogMessageProcessor(this);
        this.FProcTable[Message.CODE_PFIX_HISTORY_RESP] = new PFixHistoryMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_RISK_PLAN_MESSAGE] = new RiskPlanMessageProcessor(this);
        this.FProcTable[Message.CODE_PFIX_MAM_GROUP_MESSAGE] = new MamGroupProcessor();
        this.FProcTable[Message.CODE_PFIX_XML_MESSAGE] = new XMLMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_QUOTE2_AGGREGATED] = new Quote2AggregatedMessageProcessor(this);
        this.FProcTable[Message.CODE_PFIX_COMPRESSED_MESSAGE] = new CompressedMessageProcessor(this);
        this.FProcTable[Message.CODE_TRADE_SESSION_STATUS_MESSAGE] = new TradeSessionStatusMessageProcessor();
        this.FProcTable[Message.CODE_BUSINESS_REJECT_MESSAGE] = new BusinessRejectMessageProcessor();
        this.FProcTable[Message.CODE_INSTRUMENT_STRIKES_RESPONSE] = new NonFixedInstumentStrikesResponseMessageProcessor(this);
        this.FProcTable[Message.CODE_PFIX_LOGOUT_MESSAGE] = new LogoutMessageProcessor();
        this.FProcTable[Message.CODE_ONETIME_PASSWORD_MESSAGE] = new OneTimePasswordMessageProcessor();
        this.FProcTable[Message.CODE_TRADING_UNLOCK_MESSAGE_RESPONSE] = new TradingUnlockResponseProcessor();
        this.FProcTable[Message.CODE_COMMISSION_PLAN_MESSAGE] = new RevenuePlanMessageProcessor();
        this.FProcTable[Message.CODE_SPREAD_PLAN_MESSAGE] = new RevenuePlanMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_TRADE_INSTRUMENT] = new InstrumentUpdateMessageProcessor(this);
        this.FProcTable[Message.CODE_YTM_RESPONSE] = new YTMMessageProcessor();
        this.FProcTable[Message.CODE_TRADING_SIGNALS_REQ_MESSAGE] = new TradingSignalRequestMessageProcessor();
        this.FProcTable[Message.CODE_TRADING_SIGNAL_REQ_SEEN_MESSAGE] = new TradingSignalSeenRequestMessageProcessor();
        this.FProcTable[Message.CODE_TRADING_SIGNAL_MESSAGE] = new TradingSignalMessageProcessor();
        this.FProcTable[Message.CODE_CANCEL_TRADING_SIGNAL_MESSAGE] = new TradingSignalCancelMessageProcessor();
        this.FProcTable[Message.CODE_TRADING_SYSTEM_MESSAGE] = new TradingSystemMessageProcessor();
        this.FProcTable[Message.CODE_TRADING_SYSTEM_REMOVE_MESSAGE] = new TradingSystemRemoveMessageProcessor();
        this.FProcTable[Message.CODE_SUBSCRIPTION_STRATEGY_MESSAGE] = new SubscriptionStrategyMessageProccesor();
        this.FProcTable[Message.CODE_SUBSCRIPTION_STRATEGY_REQUEST_MESSAGE] = new SubscriptionStrategyRequestMessageProccesor();
        this.FProcTable[Message.CODE_PFIX_CHANGE_PASSWORD_REQUEST] = new ChangePasswordMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_CHANGE_TRADING_PASSWORD_REQUEST] = new ChangeTradingPasswordMessageProcessor();
        this.FProcTable[Message.CODE_TEXT_MESSAGE] = new BrokerMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_BROKER_MESSAGE_RESPONSE_CASE_RESPONSE] = new BrokerMessageResponseCaseMessageProcessor();
        this.FProcTable[Message.CODE_INFORMATION_MESSAGE] = new InformationMessageProcessor();
        this.FProcTable[Message.CODE_USER_GROUP] = new UserGroupMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_REFRESH_TOKEN] = new RefreshTokenProcessor();
        this.FProcTable[Message.CODE_PFIX_BRANDING_RULES_RESP] = new BrandingRulesMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_TRADE_SESSION_SWITCH] = new SessionSwitchMessageProcessor();
        this.FProcTable[Message.CODE_ACCOUNOPERATION_MESSAGE] = new AccountOperationMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_SOAP_RESP] = new SOAPMessageProcessor();
        this.FProcTable[Message.CODE_REPORT_GROUP_RESPONSE] = new ReportGroupResponseMessageProcessor();
        this.FProcTable[Message.CODE_MARGIN_RESP] = new MarginResponseMessageProcessor();
        this.FProcTable[Message.CODE_RISK_WARN_MESSAGE] = new RiskWarningMessageProcessor();
        this.FProcTable[Message.CODE_MARGINCALL] = new MarginCallMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_PORTFOLIO_STATISTICS_RESPONSE] = new PortfolioStatisticsMessageProcessor();
        this.FProcTable[Message.CODE_NEWS_SUBSCRIBE_RESPONSE] = new NewsSubscribeResponseProcessor();
        this.FProcTable[Message.CODE_NEWS_MESSAGE] = new NewsMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_TOKEN_VERIFY_RESPONSE] = new TokenVerifyResponseMessageProcessor();
        this.FProcTable[Message.CODE_GET_SNAPSHOT_RESPONSE] = new SnapshotResponseMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_EXTERNAL_LINK_MESSAGE] = new ExternalLinkMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_EXTERNAL_LINK_REMOVE_MESSAGE] = new ExternalLinkRemoveMessageProcessor();

        this.FProcTable[Message.CODE_PFIX_PORTFOLIO_SYSTEM_MESSAGE] = new PortfolioSystemMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_PORTFOLIO_INVESTOR_MESSAGE] = new PortfolioInvestorMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_PORTFOLIO_MODEL_MESSAGE] = new PortfolioModelMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_PORTFOLIO_REALTIME_STATISTICS] = new PortfolioRealtimeStatisticsMessageProcessor();
        // Account Operation Message
        this.FProcTable[Message.CODE_ACCOUNT_OPERATION_REQUEST_INFO_MESSAGE] = new AccountOperationInfoMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_CUSTODIAL_PLAN_MESSAGE] = new CustodialPlanMessageProcessor();

        // Alert Decoders
        this.FProcTable[Message.CODE_ALERT_MESSAGE] = new AlertMessageProcessor();
        this.FProcTable[Message.CODE_REPLACE_ALERT_MESSAGE] = new ReplaceAlertMessageProcessor();
        this.FProcTable[Message.CODE_CONTROL_ALERT_COMMAND_MESSAGE] = new ControlAlertCommandMessageProcessor();

        // Product
        this.FProcTable[Message.CODE_PFIX_PRODUCT_MESSAGE] = new EntitlementProductMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_PRODUCT_DOCUMENT_RESP] = new EntitlementProductDocumentResponseMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_PRODUCT_SUBSCRIPTION_MANAGEMENT_RESP] = new EntitlementProductSubscriptionResponseMessageProcessor();

        this.FProcTable[Message.BM_HISTORY_RESPONSE] = new BMHistoryResponseMessageProcessor();
        this.FProcTable[Message.BM_COUNTER_MESSAGE] = new BMCounterMessageProcessor();

        this.FProcTable[Message.CODE_PRICE_LIMITS_MESSAGE] = new PriceLimitsMessageProcessor();
        this.FProcTable[Message.CUSTOM_LIST_MESSAGE] = new CustomListMessageProcessor();
        // Algorithm
        this.FProcTable[Message.CODE_PFIX_ALGORITHMS_AVAILABLE_MESSAGE] = new AlgorithmsAvailableMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_ALGORITHM_SUBSCRIBE_MESSAGE] = new AlgorithmSubscribeMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_ALGORITHM_HIGH_LOW_MESSAGE] = new AlgorithmHighLowMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_ALGORITHM_GAINERS_LOSERS_MESSAGE] = new AlgorithmGainersLosersMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_ALGORITHM_MARKET_CONSENSUS_MESSAGE] = new AlgorithmMarketConsensusMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_ALGORITHM_TOP_VOLUME_MESSAGE] = new AlgorithmTopVolumeMessageProcessor();
        this.FProcTable[Message.CODE_PFIX_ALGORITHM_HISTORICAL_GAINER_LOSER_TOPS_MESSAGE] = new AlgorithmHistoricalGainersLosersTopsMessageProcessor();

        this.FProcTable[Message.CODE_RECOVERY_CHANGE_RESPONSE] = new PasswordRecoveryChangeMessageProcessor();

        this.FProcTable[Message.CODE_PFIX_FUNDING_RATE_MARKUP_PLAN_MESSAGE] = new FundingRateMarkupPlanMessageProcessor();

        this.FProcTable[Message.CODE_PFIX_CLOSE_ACCOUNT_RESPONSE_MESSAGE] = new CloseAccountResponseMessageProcessor();

        this.FProcTable[Message.CODE_PFIX_ALGORITHM_HEATMAP_MESSAGE] = new AlgorithmHeatmapMessageProcessor();
    }

    get InstrumentDecodeMap (): Record<number, string> { return this.FInstrumentDecodeMap; }

    get SymbolDecodeMap (): Record<string, number> { return this.FSymbolDecodeMap; }

    get RouteDecodeMap (): Record<number, string> { return this.FRouteDecodeMap; }

    get IdRouteDecodeMap (): Record<string, number> { return this.FIdRouteDecodeMap; }

    get QuoteRouteMap () { return this.FQuoteRouteMap; }

    get AssetDecodeMap () { return this.FAssetDecodeMap; }

    get SourceMap (): Record<number, string> { return this.FSourceDecodeMap; }

    public Decode (fieldSet: PFixFieldSet): any[] | null {
        const code = fieldSet.GetField(0);
        if (!code) {
            return null;
        }

        const proc = this.FProcTable[code.Value];
        if (!proc) {
            return null;
        }

        const messages = proc.decode(fieldSet);

        return messages;
    }

    public GetSymbolById (id: number): string {
        const map = this.FInstrumentDecodeMap;
        return map.hasOwnProperty(id) ? map[id] : '';
    }

    // Получить идентификатор по символу
    public GetIdBySymbol (symbol: string): number {
        const map = this.FSymbolDecodeMap;
        return map.hasOwnProperty(symbol) ? map[symbol] : -1;
    }

    public GetRouteById (id: number): string {
        const map = this.FRouteDecodeMap;
        return map.hasOwnProperty(id) ? map[id] : '';
    }

    public GetRouteIdByName (name: string): number {
        const map = this.FIdRouteDecodeMap;
        return map.hasOwnProperty(name)
            ? map[name]
            : -1;
    }

    public GetRouteQuoteId (routeId) {
        const map = this.FQuoteRouteMap;
        return map.hasOwnProperty(routeId)
            ? map[routeId]
            : routeId;
    }

    public GetSourceById (routeId: number, sourceId: number): string {
        const FSourceDecodeMap = this.FSourceDecodeMap;
        if (!FSourceDecodeMap.hasOwnProperty(routeId)) {
            return '';
        }

        const ht = FSourceDecodeMap[routeId];
        if (ht !== null && ht.hasOwnProperty(sourceId)) {
            return ht[sourceId];
        } else {
            return '';
        }
    }

    public FindRequestTime (msg): number {
        const parent = this.parent;
        return parent ? parent.FindRequestTime(msg) : 0;
    }
}
